/**
 * Renders the template within the given environment
 * @param {string} tmpl The template to render
 * @param {Object.<string, string>} environment The environment to evaluate the expressions in
 */
function renderTemplate (tmpl, environment) {
    return tmpl.replace(/\{([a-z0-9]+)\}/gi, function (_completeMatch, varName) {
        if (environment[varName]) {
            return environment[varName];
        } else {
            return '';
        }
    });
}

/**
 * Renders the template within the given environment
 * @param {string} id The ID of the HTML element containing the template to render
 * @param {Object.<string, string>} environment The environment to evaluate the expressions in
 */
function applyRendering (id, environment) {
    return renderTemplate(document.getElementById(id).innerHTML, environment);
}

export {
    applyRendering
};
